import { Component, OnInit } from "@angular/core";
import { GeoResponse } from "src/app/interfaces/geo-interface";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { JurisdictionService } from "src/app/services/geo/jurisdiction.service";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { WebservicesService } from "src/app/services/webservices/webservices.service";
import { Storage } from "@ionic/storage-angular";
import { LogoutService } from "src/app/services/logout/logout.service";
import { GamesService } from "src/app/services/lobby/games.service";
import { LobbyApiService } from "src/app/services/lobby/lobby.api.service";

@Component({
  selector: "app-game-automation",
  templateUrl: "./game-automation.component.html",
  styleUrls: ["./game-automation.component.scss"],
})
export class GameAutomationComponent implements OnInit {
  gameArraywithKeywords: any = [];
  allGamesDataArray: any = [];
  geoStatusText: string;
  isAutomationRunning: boolean = false;
  gameVendorSessionID: any;
  delayLaunchGame: any;
  delayGameKill: any;
  filteredGameArray: any = [];
  vendorsName = [];
  lobbyList: any = [];
  vendor_name_config: any;
  default_vendor_name: any;
  breakLoop: boolean = false;
  gameResult: boolean = false;
  gameResultApiFailed: boolean = null;
  private pollIntervalPeriodLength: number = 15000;
  private pollCounter: number = 0;
  private pollMaxLength: number = 8; // Poll every 15 sec for 8 times = 2 minutes
  private pollInterval: any;
  private livedealerEnabled: boolean = false;
  constructor(
    private config: ConfigService,
    private webservices: WebservicesService,
    protected jurisdiction: JurisdictionService,
    private userSessionService: UserSessionService,
    private storage: Storage,
    protected events: EventsService,
    public lobbyService: LobbyService,
    private logoutService: LogoutService,
    private gameService: GamesService,
    private gameHubController: GameHubControllerService,
    private lobbyApiService: LobbyApiService
  ) {
    this.storage.create();
  }

  ngOnInit() {
    this.lobbyList = this.config.getConfig()
    .IOS_GAME_AUTOMATION_STATES
    ? JSON.parse(this.config.getConfig().IOS_GAME_AUTOMATION_STATES)
    : ["PA"];
    this.delayLaunchGame = this.config.getConfig()
      .IOS_GAME_AUTOMATION_LAUNCH_DELAY
      ? this.config.getConfig().IOS_GAME_AUTOMATION_LAUNCH_DELAY
      : "5";
    //let vendor_name_config = this.config.getConfig().IOS_GAME_AUTOMATION_VENDOR_NAME ? this.config.getConfig().IOS_GAME_AUTOMATION_VENDOR_NAME : 'all';
    this.delayGameKill = this.config.getConfig()
      .IOS_GAME_AUTOMATION_GAME_KILL_DELAY
      ? this.config.getConfig().IOS_GAME_AUTOMATION_GAME_KILL_DELAY
      : "5";
      this.livedealerEnabled = this.config.getConfig().LD_GAME_AUTOMATION_ENABLED === '1' ? true : false;
    // this.listGames("CASINONJMAIN");
  }

  startGeo() {
    this.jurisdiction
      .verifyJurisdiction(() => this.startGeo())
      .then((geoResp: GeoResponse) => {
        return this.startGameAutomation();
      })
      .catch((err: any) => {
        console.log("main.ts: catch err after verifyJurisdiction: ", err);
      });
  }

  startGameAutomation() {
    console.log("--startGameAutomation--", this.vendor_name_config);
    //Running based on vendor_name_config...smaller test
    let gameTest;
    if (this.vendor_name_config == "all") {
      //Sort the All vendors by alphabetical order.
      this.filteredGameArray.sort((vendorA, vendorB) => {
        let firstVendor = vendorA.vendor_ident.toUpperCase();
        let nextVendor = vendorB.vendor_ident.toUpperCase();
        return firstVendor < nextVendor ? -1 : firstVendor > nextVendor ? 1 : 0;
      });
      //Now reverse the array so, for loop starts from Alphabetical order for all games testing case
      this.filteredGameArray.reverse();
    } else {
      gameTest = this.filteredGameArray.filter(
        (x) => {
          return this.filterGames(x, this.vendor_name_config) 
        });
      //Sort the All games by alphabetical order.
      gameTest.sort((gameA, gameB) => {
        let firstGame = gameA.game_name.toUpperCase();
        let nextGame = gameB.game_name.toUpperCase();
        return firstGame < nextGame ? -1 : firstGame > nextGame ? 1 : 0;
      });
      //Now reverse the array so, for loop starts from Alphabetical order for all games testing case
      gameTest.reverse();
      console.log("--ordered game--", gameTest);
      this.filteredGameArray = gameTest;
    }
    this.geoStatusText = `You are running ${this.vendor_name_config} game test`;
    this.isAutomationRunning = true;
    this.lobbyService.setAutomationRunning(this.isAutomationRunning);
    console.log(`you are running ${this.vendor_name_config} game test`);
    console.log("--Final game list for automation--");
    console.log(this.filteredGameArray);

    console.log("--startGameAutomation--22");
    setTimeout(() => {
      console.log("--startGameAutomation--33");
      this.storage.set("game.automation", true);
      this.startGameIterationLoop();
    }, 2000);
  }

  async startGameIterationLoop() {
    Gameloop: for (
      let game = this.filteredGameArray.length - 1;
      game >= 0;
      game--
    ) {
      await this.delay(this.delayLaunchGame);
      this.gameHubController.launchCasinoGame(this.filteredGameArray[game]);
      console.log("Promise based polling logic starts........");
      await this.startPollingForGameStatus(this.filteredGameArray[game]);
      console.log(
        "Promise based polling logic ends....resets the variables for next game iteration check........."
      );
      //another dealy as per QA request so, they can see which game is running
      await this.delay(this.delayGameKill);
      this.gameHubController.killAllInstances();
      // this.gameHubController.closeOdrInstanceWindow();
      //clear the game Session ID from the previous game so, next game have proper game session ID assigned.
      //Tag_not_found, game_loading_error will be fixed and will not send any game session so, report will show these types of games under 'No Game Session For:'

      this.lobbyService.clearGameSessionID(); //
      this.gameVendorSessionID = "";
      this.gameResult = false;
      this.gameResultApiFailed = null;
      this.pollIntervalPeriodLength = 15000;
      this.pollCounter = 0;
      this.pollMaxLength = 8;
      this.filteredGameArray.splice(game, 1);
      if (this.breakLoop) break Gameloop;
      this.events.publish("event:inactivity:reset");
      console.log(this.filteredGameArray);
    }
    console.log("end of loop--", this.filteredGameArray);
    clearInterval(this.pollInterval);
    //to do - logout logic after test is complete
    this.breakLoop = false;
    this.isAutomationRunning = false;
    this.lobbyService.setAutomationRunning(this.isAutomationRunning);
    this.logoutService.onLogout({
      code: "ODR_AUTOMATED_TEST",
      reason: "ODR_AUTOMATED_TEST",
    });
  }

  listGames(lobby: string) {
    this.getGames(lobby).subscribe((response) => {
      console.log("game response", response);

      this.gameArraywithKeywords = response.payload;

      //make allGames array so, it's get easier to loop through
      let casinoGames = this.gameArraywithKeywords;
      let allCasinoGames: any = Object.keys(this.gameArraywithKeywords).map(
        function (key) {
          return casinoGames[key.toString()];
        }
      );
      this.allGamesDataArray = allCasinoGames.reduce(function (a, b) {
        return a.concat(b);
      }, []);
      console.log("--this is all games array including duplicates--");
      console.log(this.allGamesDataArray);

      //Removing duplicates games from the allGamesDataArray
      let removingDuplicates = new Set();
      this.filteredGameArray = this.allGamesDataArray.filter((el) => {
        let duplicate = removingDuplicates.has(el.id);
        removingDuplicates.add(el.id);
        return !duplicate;
      });
      console.log(
        "--this is all games array after removing duplicate game IDs--"
      );
      console.log(this.filteredGameArray);

      //List out the game vendors and create Array
      let flags = [],
        total = this.filteredGameArray.length,
        i;
      this.vendorsName = [];
      for (i = 0; i < total; i++) {
        if (flags[this.filteredGameArray[i].vendor_ident]) continue;
        flags[this.filteredGameArray[i].vendor_ident] = true;
        this.vendorsName.push(this.filteredGameArray[i].vendor_ident);
      }
      //Removing All game vendor option as of now.
      //this.vendorsName.push('all');
      console.log("---total game vendors for this client---", this.vendorsName);
      //Now, Sort the Vendors name in Alphabetical Order
      this.vendorsName.sort((vendorA, vendorB) => {
        let firstVendor = vendorA.toUpperCase();
        let nextVendor = vendorB.toUpperCase();
        return firstVendor < nextVendor ? -1 : firstVendor > nextVendor ? 1 : 0;
      });
      this.vendor_name_config = this.vendorsName[0];
      console.log(
        "---total game vendors for this client in sorted order---",
        this.vendorsName
      );
    });
  }

  getGames(lobby_name: string) {
    console.log("--getGames--");
    return this.lobbyApiService.fetchGamesByLobbyName(lobby_name);
  }

  delay(ms) {
    console.log(`----${ms} seconds delay----`);
    return new Promise((resolve) => setTimeout(resolve, ms * 1000));
  }

  stopGametest() {
    this.gameHubController.killAllInstances();
    clearInterval(this.pollInterval);
    this.breakLoop = true;
    this.isAutomationRunning = false;
    this.storage.get("game.automation").then((value) => {
      if (value) {
        this.breakLoop = value;
      }
    });

    this.logoutService.onLogout({
      code: "ODR_AUTOMATED_TEST",
      reason: "ODR_AUTOMATED_TEST",
    });
  }

  startPollingForGameStatus(gameInfo: any) {
    return new Promise((resolve, reject) => {
      this.pollInterval = setInterval(() => {
        console.log("polling........");
        console.log(this.pollInterval, this.gameResult, typeof this.gameResult);
        if (
          this.pollCounter < this.pollMaxLength &&
          this.gameResult === false
        ) {
          //Needs to confirm for session ID which is only added for launchInappbrowser in the odr-controller.ts
          if (gameInfo.vendor_ident == "internal") {
            this.gameVendorSessionID = this.lobbyService.getGameSessionID();
            console.log("----Internal game ID---", this.gameVendorSessionID);
            this.checkInternalGameResult(this.gameVendorSessionID);
          } else {
            this.gameVendorSessionID = this.lobbyService.getGameSessionID();
            console.log("----game session---", this.gameVendorSessionID);
            this.checkExternalGameResult(this.gameVendorSessionID);
          }
          this.pollCounter++;
        } else {
          console.log("polling done......");
          //need to clear the timeout somehow after polling is done.
          clearInterval(this.pollInterval);
          resolve(this);
        }
      }, this.pollIntervalPeriodLength);
    });
  }

  checkExternalGameResult(gameSession: any) {
    let obj: any = {
      game_session_token: gameSession,
      session_token: this.userSessionService.getSessionToken(),
    };

    this.webservices.get("games/external-game-session-used", obj).subscribe({
      next: (response: any) => {
        console.log("checkExternalGameResult: next");
        if (response) {
          this.gameResult = response.payload;
        }
      },
      error: (error: any) => {
        console.log("checkExternalGameResult: error");
        console.log(error);
        this.gameResultApiFailed = false;
      },
    });
  }

  checkInternalGameResult(gameID: any) {
    let obj: any = {
      id: gameID,
      session_token: this.userSessionService.getSessionToken(),
    };

    this.webservices.get("games/internal-game-session-created", obj).subscribe({
      next: (response: any) => {
        console.log("checkInternalGameResult: next");
        if (response) {
          this.gameResult = response.payload;
        }
      },
      error: (error: any) => {
        console.log("checkInternalGameResult: error");
        console.log(error);
        this.gameResultApiFailed = false;
      },
    });
  }

  onChangeLobby(lobby: string) {
    if(lobby == 'PA'){
      this.listGames("CASINOPAMAIN");
    } else if(lobby == 'NJ') {
      this.listGames("CASINONJMAIN");
    } else if(lobby == 'ON') {
      this.listGames("CASINOONMAIN");
    }
  }

  filterGames(x, venderConfigName) {
    if (this.livedealerEnabled) {
      return (x.vendor_ident == venderConfigName)
    }
    return (x.vendor_ident == venderConfigName && x.super_type != "LIVE_DEALER")
  }
 }
